var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('purchases-order-form',{attrs:{"loading":_vm.loading,"purchasesOrderData":_vm.purchasesOrder,"formErrors":_vm.formErrors},on:{"purchasesOrderSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }